import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const paymentsApi = createApi({
  reducerPath: "paymentsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_API,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().userSlice?.token;
      if (token) {
        headers.set("Authorization", `bearer ${token}`);
      }
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getPayments: builder.query({
      query: () => ({
        url: "payment_type",
        method: "GET",
      }),
    }),
    navigatePaymentPage: builder.mutation({
      query: () => ({
        url: "payment/url",
        method: "GET",
      }),
    }),
    check_payment: builder.mutation({
      query: (tCode) => ({
        url: `payment/check_payment?order_tcode=${tCode}`,
        method: "GET",
      }),
    }),
  }),
});
export const { useGetPaymentsQuery, useNavigatePaymentPageMutation , useCheck_paymentMutation } =
  paymentsApi;
